import { useRef } from "react";
import { useQuery } from "shared/hooks/useApi";
import { FIELD_REGISTRY } from "utils/api/graphql/queries/screens";

/**
 * `processId` adds that process's custom fields under the `custom` entity.
 * Without it the query returns only canonical fields, exactly as before.
 */
export const useFieldRegistry = (processId) => {
  const { data } = useQuery(FIELD_REGISTRY, {
    variables: processId ? { process: { id: processId } } : {},
  });
  const registry = data?.fieldRegistry || [];
  const ref = useRef(registry);
  ref.current = registry;
  return { registry, registryRef: ref };
};
